import { render } from "./FieldInfo.vue?vue&type=template&id=33c1ffcb&scoped=true"
import script from "./FieldInfo.vue?vue&type=script&lang=js"
export * from "./FieldInfo.vue?vue&type=script&lang=js"

import "./FieldInfo.vue?vue&type=style&index=0&id=33c1ffcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c1ffcb"]])

export default __exports__